<template>
  <span ref="root" class="agent-info-tooltip">
    <button
      type="button"
      class="agent-info-tooltip-button"
      :aria-label="ariaLabel"
      :aria-expanded="open ? 'true' : 'false'"
      @click.stop="toggle"
      @keydown.esc="close"
    >
      <i class="fa fa-info-circle"></i>
    </button>
    <span v-if="open" class="agent-info-tooltip-popover" role="tooltip">
      {{ text }}
    </span>
  </span>
</template>

<script>
export default {
  name: "InfoTooltip",
  props: {
    text: {
      type: String,
      required: true
    },
    ariaLabel: {
      type: String,
      default: "Buka penjelasan"
    }
  },
  data() {
    return {
      open: false
    };
  },
  mounted() {
    document.addEventListener("click", this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
    onDocumentClick(event) {
      if (!this.open) return;
      if (this.$refs.root && this.$refs.root.contains(event.target)) return;
      this.close();
    }
  }
};
</script>

<style scoped>
.agent-info-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.agent-info-tooltip-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #98a2b3;
  padding: 0;
  cursor: pointer;
}
.agent-info-tooltip-button:hover,
.agent-info-tooltip-button:focus {
  color: #fe9b44;
  outline: none;
  background: #fff4e8;
}
.agent-info-tooltip-popover {
  position: absolute;
  z-index: 80;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: 310px;
  max-width: calc(100vw - 40px);
  border: 1px solid #e7eaf0;
  border-radius: 10px;
  background: #fff;
  color: #475467;
  box-shadow: 0 12px 30px rgba(16, 24, 40, .14);
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.55;
  text-align: left;
}
@media (max-width: 575px) {
  .agent-info-tooltip-popover {
    left: 0;
    transform: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ai/agentV2/components/InfoTooltip.vue